import { SupportingContent } from "@wayflyer/flyui";
import { useIntl } from "react-intl";
import { useInviteModalActions } from "shared-ui";

import { COMMON_MESSAGES } from "../common-messages";

export const ManagementAccountsUploadSupportingContent = () => {
  const intl = useIntl();
  const { openInviteModal } = useInviteModalActions();
  const openInviteModalHandler = () => {
    openInviteModal();
  };
  return (
    <>
      <SupportingContent
        securityInfo={{
          label: intl.formatMessage({
            id: "funding-application: data security statement",
            defaultMessage: "Your data is securely stored in encrypted databases",
          }),
          link: {
            external: true,
            linkText: intl.formatMessage(COMMON_MESSAGES.viewOurPrivacyNotice),
            url: "https://www.wayflyer.com/privacy-notice",
          },
        }}
        supportingLinks={{
          heading: intl.formatMessage({
            id: "funding-application: need help",
            defaultMessage: "Need help?",
          }),
          links: [
            {
              linkText: intl.formatMessage({
                id: "funding-application: invite for doc upload",
                defaultMessage: "Invite a team member to upload documents for you.",
              }),
              onClick: openInviteModalHandler,
            },
            {
              external: true,
              linkText: intl.formatMessage({
                id: "funding-application: why are management accounts required",
                defaultMessage: "Why are management accounts required?",
              }),
              url: "https://help-center.wayflyer.com/articles/284405-why-are-my-management-accounts-required",
            },
            {
              external: true,
              linkText: intl.formatMessage({
                id: "funding-application: what do you use my accounting data for",
                defaultMessage: "What do you use my accounting data for?",
              }),
              url: "https://help-center.wayflyer.com/articles/142407-what-does-wayflyer-use-my-accounting-data-for",
            },
            {
              external: true,
              url: "https://help-center.wayflyer.com",
              linkText: intl.formatMessage({
                id: "funding-application: learn more in our health center",
                defaultMessage: "Learn more in our Help Center",
              }),
            },
          ],
        }}
      />
    </>
  );
};
